<!-- Sidebar lateral -->
<p-sidebar [(visible)]="displaySidebar" styleClass="side-bar-menu">
  <div class="profile-companie">
    <div class="companie-image">
      <!-- Aquí puedes poner el logo de la empresa si deseas -->
    </div>
  </div>

  <hr class="style-two" />

  <div class="sidebar-profile-block">
    <div class="profile-image">
      <img src="../../../assets/images/user-icon.png" alt="usuario" />
    </div>
    <div class="profile-info">
      <div class="info-name t-subtitle2 tc-w" title="{{ user.name }}">
        {{ user.name }}
      </div>
    </div>
  </div>

  <hr class="style-two" />

  <p-menu [model]="menuItems" styleClass="menu" (click)="stop($event)"></p-menu>
</p-sidebar>

<!-- Navbar superior -->
<div class="nav-bar p-shadow-4 pd-flex bgc-main">
  <!-- Lado izquierdo del navbar -->
  <div class="nav-bar-inside-left mr-2">
   <p-button
  icon="pi pi-bars"
  styleClass="p-button-rounded p-button-text p-button-white nav-bar-toggle-button text-white"
  (click)="tgSidebar()"
></p-button>

    <div class="nav-bar-title t-h5 tc-w text-white ms-2" >
      <div class="logo">
        <img src="../../../assets/images/hm_logo_header-trans.svg" alt="LogoHM" />
      </div>
    </div>
  </div>

  <!-- Lado derecho del navbar -->
  <div class="nav-bar-inside-right">
    <div class="profile-block">
      <div class="profile-image">
        <img src="../../../assets/images/user-icon.png" alt="usuario" />
      </div>
      <div class="profile-info">
        <div class="info-name t-subtitle2 tc-w">
          {{ user.name }}
        </div>
      </div>
    </div>

    <p-button
      icon="pi pi-sign-out"
      styleClass="p-button-rounded p-button-text p-button-white text-white ms-3"
      pTooltip="Cerrar sesión"
      tooltipPosition="left"
      (click)="salir()"
    ></p-button>
  </div>
</div>

<!-- Contenido principal -->
<div class="content mt-0">
  <router-outlet></router-outlet>
</div>
